import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { ChatService } from './services/chat.service';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';

import { EgiTableComponent } from './components/egi-table/egi-table.component';
import { DataTablesModule } from 'angular-datatables';
import { NgSelectModule } from '@ng-select/ng-select';
import { EgiKpiComponent } from './components/egi-kpi/egi-kpi.component';
import { EgiCardComponent } from './components/egi-card/egi-card.component';
import { EgiInfoComponent } from './components/egi-info/egi-info.component';
import { EgiComparisonComponent } from './components/egi-comparison/egi-comparison.component';
import { EgiGraphComponent } from './components/egi-graph/egi-graph.component';
import { EgiModalComponent } from './components/egi-modal/egi-modal.component';
import { DynamicFontSizeDirective } from './directives/dynamic-font-size.directive';
import { EgiTimelineComponent } from './components/egi-timeline/egi-timeline.component';
import { CustDetailsModalComponent } from './components/cust-details-modal/cust-details-modal.component';
import { ApplicationPipesModule } from './application-pipes.module';
import { CommonModule } from '@angular/common';
import { FileBtnGroupComponent } from './components/file-btn-group/file-btn-group.component';
import { CoOpMailerComponent } from './components/co-op-mailer/co-op-mailer.component';
import { EgiFileParserComponent } from './components/egi-file-parser/egi-file-parser.component';
import { FileViewerComponent } from './components/file-viewer/file-viewer.component';
import { EgiBreadcrumbComponent } from './components/egi-breadcrumb/egi-breadcrumb.component';
import { EgiDaterangePickerComponent } from './components/egi-daterange-picker/egi-daterange-picker.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { EgiNouiSliderComponent } from './components/egi-noui-slider/egi-noui-slider.component';
import { MatSliderModule } from '@angular/material/slider';

const config: SocketIoConfig = {
  url: 'http://192.168.240.48:3000',
  options: {},
};

@NgModule({
  exports: [
    FormsModule,
    NgbModule,
    CodemirrorModule,
    EgiTableComponent,
    EgiKpiComponent,
    EgiCardComponent,
    EgiTableComponent,
    EgiInfoComponent,
    EgiComparisonComponent,
    EgiGraphComponent,
    EgiModalComponent,
    EgiTimelineComponent,
    CustDetailsModalComponent,
    DynamicFontSizeDirective,
    CommonModule,
    ApplicationPipesModule,
    FileBtnGroupComponent,
    CoOpMailerComponent,
    EgiFileParserComponent,
    FileViewerComponent,
    EgiDaterangePickerComponent,
    EgiNouiSliderComponent,
    EgiBreadcrumbComponent,
  ],
  imports: [
    ApplicationPipesModule,
    NgbModule,
    //SocketIoModule.forRoot(config)
    CodemirrorModule,
    DataTablesModule,
    NgSelectModule,
    FormsModule,
    CommonModule,
    MatSliderModule,
    NgxDaterangepickerMd.forRoot(),
  ],
  declarations: [
    EgiTableComponent,
    EgiKpiComponent,
    EgiCardComponent,
    EgiInfoComponent,
    EgiComparisonComponent,
    EgiGraphComponent,
    EgiModalComponent,
    DynamicFontSizeDirective,
    EgiTimelineComponent,
    CustDetailsModalComponent,
    FileBtnGroupComponent,
    CoOpMailerComponent,
    EgiFileParserComponent,
    FileViewerComponent,
    EgiBreadcrumbComponent,
    EgiDaterangePickerComponent,
    EgiNouiSliderComponent,
    EgiBreadcrumbComponent,
  ],
  providers: [ChatService],
})
export class SharedModule {}
